module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Field Name"
    },
    on: {
      "change": _vm.setIdentifier
    },
    model: {
      value: (_vm.field.name),
      callback: function($$v) {
        _vm.$set(_vm.field, "name", $$v)
      },
      expression: "field.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field Identifier",
      "disabled": Boolean(_vm.field._id)
    },
    on: {
      "dblclick": _vm.setIdentifier
    },
    model: {
      value: (_vm.field.identifier),
      callback: function($$v) {
        _vm.$set(_vm.field, "identifier", $$v)
      },
      expression: "field.identifier"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fieldTypes,
      "item-text": "name",
      "item-value": "name",
      "label": "Field Type"
    },
    model: {
      value: (_vm.field.type),
      callback: function($$v) {
        _vm.$set(_vm.field, "type", $$v)
      },
      expression: "field.type"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.controlTypes,
      "item-text": "name",
      "item-value": "name",
      "label": "Control Type"
    },
    model: {
      value: (_vm.field.control),
      callback: function($$v) {
        _vm.$set(_vm.field, "control", $$v)
      },
      expression: "field.control"
    }
  }), _vm._v(" "), (_vm.field.type == 'List') ? _c('v-text-field', {
    attrs: {
      "label": "Options"
    },
    model: {
      value: (_vm.field.options),
      callback: function($$v) {
        _vm.$set(_vm.field, "options", $$v)
      },
      expression: "field.options"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.type == 'Calculated') ? _c('v-text-field', {
    attrs: {
      "label": "Expression"
    },
    model: {
      value: (_vm.field.expression),
      callback: function($$v) {
        _vm.$set(_vm.field, "expression", $$v)
      },
      expression: "field.expression"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.field._id) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01a99c42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/system/FieldDialog.vue
// module id = 2426
// module chunks = 1